export const BASE_THEME_ID = 'base';
export const BASE_DARK_THEME_ID = `${BASE_THEME_ID}.dark`;
export const LOCAL_STORAGE_THEME_MODE_KEY = 'themeMode';

export const DEFAULT_OUTLOOK_THEME_COLOR = '#0078D4';
export const DEFAULT_OUTLOOK_DARK_THEME_COLOR = '#0086F0';

export const THEME_MODE_SYSTEM_DARK = 'System Dark';
export const THEME_MODE_SYSTEM_LIGHT = 'System Light';
export const THEME_MODE_LIGHT = 'Light';
export const THEME_MODE_DARK = 'Dark';
